// @flow
import { SUGGEST_SEARCH, SUGGEST_SET_ITEM, SUGGEST_SET_ITEMS, SUGGEST_SEARCH_VIA_BACKEND, SUGGEST_RESET } from './constants';
export var search = function search(query) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: SUGGEST_SEARCH,
    payload: {
      query: query,
      options: options
    }
  };
};
export var searchViaBackend = function searchViaBackend(query) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: SUGGEST_SEARCH_VIA_BACKEND,
    payload: {
      query: query,
      options: options
    }
  };
};
export var setItem = function setItem(item) {
  return {
    type: SUGGEST_SET_ITEM,
    payload: {
      item: item
    }
  };
};
export var setItems = function setItems(items) {
  return {
    type: SUGGEST_SET_ITEMS,
    payload: {
      items: items
    }
  };
};
export var reset = function reset() {
  return {
    type: SUGGEST_RESET,
    resource: 'suggestions'
  };
};
//# sourceMappingURL=suggestions.js.map